import { cn } from '@/lib/utils'
import { forwardRef } from 'react'

export interface HomeFeatureItemProps extends React.HTMLAttributes<HTMLDivElement> {
  icon: React.ReactNode
  text: string
  iconPosition?: 'left' | 'top'
}

const HomeFeatureItem = forwardRef<HTMLDivElement, HomeFeatureItemProps>(
  ({ className, icon, text, iconPosition = 'left', ...props }, ref) => {
    return (
      <div
        className={cn(
          'flex items-center',
          iconPosition === 'left' ? 'space-x-3' : 'flex-col space-y-2 text-center',
          className,
        )}
        ref={ref}
        {...props}
      >
        <div className='text-primary-500'>{icon}</div>
        <span className='text-lg text-neutral-800'>{text}</span>
      </div>
    )
  },
)

HomeFeatureItem.displayName = 'HomeFeatureItem'

export { HomeFeatureItem }
